var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCaretDownSolid(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M16.031 17.684c-.562.609-1.546.609-2.109 0l-6-6a1.516 1.516 0 01-.328-1.641A1.535 1.535 0 019 9.105h12c.563 0 1.125.375 1.36.938a1.516 1.516 0 01-.329 1.64l-6 6z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCaretDownSolid);
export default ForwardRef;
